import React from 'react';
import { Step } from 'components/Wizard';
import VideoWizardExportStep, {
  VideoWizardExportStepProps,
} from '../VideoWizardExportStep';
import { VideoFlowInternalErrorHandler, VideoFlowStep } from './types';

export type UseExportStepProps = Pick<
  VideoWizardExportStepProps,
  'isFullEpisode' | 'mainVideoSrc' | 'videoFileSize'
> & {
  onError: VideoFlowInternalErrorHandler;
};

export default function useExportStep(props: UseExportStepProps) {
  const step: Step<VideoFlowStep.EXPORT> = {
    name: 'finish',
    component: <VideoWizardExportStep {...props} />,
    renderCancelButton: () => null,
    renderNextButton: () => null,
    showInNav: false,
    stepId: VideoFlowStep.EXPORT,
  };

  return {
    step,
  };
}
